module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_nipa.c4f13691e1161708254208336f95b2ea.png";